import { createContext, useContext } from "react";

/**
 * Registry of editable rows so the editor can flush (save) pending drafts
 * before it switches feature, leaves, or reloads.
 */
export function createDraftRegistry() {
  const rows = new Map();
  const listeners = new Set();
  const emit = () => listeners.forEach((fn) => fn());
  return {
    register(id, api) {
      rows.set(id, api);
      emit();
      return () => {
        if (rows.get(id) === api) rows.delete(id);
        emit();
      };
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    /** Rows call this when their dirty flag changes so the header can update. */
    note() { emit(); },
    hasUnsaved() {
      for (const api of rows.values()) if (api.isDirty()) return true;
      return false;
    },
    /** Save every dirty row; resolves true when all saved (incomplete new rows count as not saved). */
    async flushAll() {
      const results = await Promise.all([...rows.values()].map((api) => api.flush()));
      return results.every(Boolean);
    },
  };
}

export const DraftRegistryContext = createContext(null);
export const useDraftRegistry = () => useContext(DraftRegistryContext);
